import { render, staticRenderFns } from "./XyReturn.vue?vue&type=template&id=c0024cf0&scoped=true"
import script from "./XyReturn.vue?vue&type=script&lang=js"
export * from "./XyReturn.vue?vue&type=script&lang=js"
import style0 from "./XyReturn.vue?vue&type=style&index=0&id=c0024cf0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0024cf0",
  null
  
)

export default component.exports